import React from 'react';

const Title = ({className = '', heading = 'heading-1', display = 'display-3', ...props}) => {
    let titleOptions = `head-title ${className} ${display}`;
    if (heading === "heading-1") {
        return (
            <h1 className={titleOptions} {...props} >
                {props.children}
            </h1>
        )
    } else if (heading === "heading-2") {
        return (
            <h2 className={titleOptions} {...props} >
                {props.children}
            </h2>
        )
    } else if (heading === "heading-3") {
        return (
            <h3 className={titleOptions} {...props} >
                {props.children}
            </h3>
        )
    } else if (heading === "heading-4") {
        return (
            <h4 className={titleOptions} {...props} >
                {props.children}
            </h4>
        )
    } else if (heading === "heading-5") {
        return (
            <h5 className={titleOptions} {...props} >
                {props.children}
            </h5>
        )
    } else if (heading === "heading-6") {
        return (
            <h6 className={titleOptions} {...props} >
                {props.children}
            </h6>
        )
    } else {
        return (
            <div className={titleOptions} {...props}>
                {props.children}
            </div>
        )
    }
};

export default Title;